export const PLUGIN_CDN_URL_KEY = 'plugin-cdn';
